import { shortcut } from 'app/stores/keyboard/shortcuts';
export const KeyboardActions = {
    shortcut,
};
